import React from 'react';
import { MessageSquare } from 'lucide-react';
import { moduleApi } from '../../lib/api';
import { TeamMessagingSettings } from './TeamMessagingSettings';

interface EmployeeOption {
    id: string;
    first_name: string;
    last_name: string;
}

export const TeamMessagingPage: React.FC = () => {
    const [employees, setEmployees] = React.useState<EmployeeOption[]>([]);

    React.useEffect(() => {
        moduleApi.getEmployes().then((d: any) => setEmployees(Array.isArray(d) ? d : [])).catch(() => setEmployees([]));
    }, []);

    return (
        <div className="space-y-6">
            <header>
                <h1 className="text-3xl font-bold tracking-tight text-content flex items-center gap-2"><MessageSquare size={24} /> Messagerie</h1>
                <p className="text-content-muted mt-1">Envoyez des annonces à vos salariés et suivez leurs réponses.</p>
            </header>
            <TeamMessagingSettings employees={employees} />
        </div>
    );
};

export default TeamMessagingPage;
